import {createContext, useContext, ReactNode, Dispatch, SetStateAction} from "react";

type DndContextValue = {
  onSelectItem: (e, path) => void;
  isMultipleSelected: boolean;
  resetSelectedItems: () => void;
  isDragInProgress: boolean;
  setIsDragInProgress: Dispatch<SetStateAction<boolean>>;
}

const DndContext = createContext(null);

export const DndProvider = ({ value, children }: {
  value: DndContextValue, children: ReactNode
}) => {
  return (
    <DndContext.Provider value={value}>
      {children}
    </DndContext.Provider>
  )
};

export const useDnd = () => useContext(DndContext);
